import SEO from '../../components/SEO';
import React, { useState } from 'react';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import AppointmentModal from '../../components/AppointmentModal';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ParentingCounselingPage = () => {
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [insuranceProviders, setInsuranceProviders] = useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const insuranceRes = await axios.get(`${API}/insurance`);
        setInsuranceProviders(insuranceRes.data);
      } catch (error) {
        // Error handled silently
      }
    };
    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <SEO title="Parenting Counseling" description="Parenting support and family counseling at SDORA Wellbeing in Pikesville, MD. Strengthening parent-child relationships through evidence-based approaches. Accepting Medicaid." path="/services/parenting-counseling" />
      
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-green-600 to-teal-600 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Counseling and Parenting
          </h1>
          <p className="text-xl md:text-2xl text-green-100 max-w-3xl">
            Strengthen parenting skills and create a nurturing, supportive home environment.
          </p>
        </div>
      </div>

      {/* Service Description */}
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">What is Counseling and Parenting?</h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Counseling and Parenting provides guidance and support to parents and caregivers seeking to strengthen their parenting skills and deepen their understanding of child development. Our counselors help improve parent-child relationships, support effective discipline strategies, and create nurturing, supportive home environments.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4">Benefits</h3>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-green-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Deeper understanding of child development and needs</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-green-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Effective discipline techniques and boundary-setting</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-green-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Stronger, more trusting parent-child bonds</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-green-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">A calmer, more supportive home atmosphere</span>
              </li>
            </ul>

            <button
              onClick={() => setShowAppointmentModal(true)}
              className="w-full md:w-auto bg-green-600 text-white px-8 py-4 rounded-lg hover:bg-green-700 transition-colors font-semibold text-lg"
            >
              Schedule Consultation
            </button>
          </div>
        </div>
      </div>

      <Footer />
      
      {showAppointmentModal && (
        <AppointmentModal 
          onClose={() => setShowAppointmentModal(false)}
          insuranceProviders={insuranceProviders}
        />
      )}
    </div>
  );
};

export default ParentingCounselingPage;